import "babel-polyfill";

import React from 'react';
import PerspectiveSelectItem from './PerspectiveSelectItem.js';
import TextSuggestBox from './TextSuggestBox.js';
import TextEditorBox from './TextEditorBox.js';
// import "ie-array-find-polyfill";

class DesignerPerspectiveEditor extends React.Component {

    constructor(props) {
        super(props);

        this.handleSelect = this.handleSelect.bind(this);
        this.handleSuggestTextSelect = this.handleSuggestTextSelect.bind(this);
        this.handleContentLayerChange = this.handleContentLayerChange.bind(this);
    }

    getMaxCharsCount()
    {
        let count = 60;
        
        if (this.props.perspective.max_chars > 0)
            count = this.props.perspective.max_chars;
            
        if (this.props.activeDesignerVariants !== null && this.props.activeDesignerVariants !== undefined && this.props.activeDesignerVariants.length > 0)
        {
            for (var varI = 0; varI < this.props.activeDesignerVariants.length; varI++) {

                if (this.props.activeDesignerVariants[varI].selectedVar === null || this.props.activeDesignerVariants[varI].selectedVar === undefined)
                    continue;

                if (this.props.activeDesignerVariants[varI].selectedVar.max_chars > 0 && this.props.activeDesignerVariants[varI].selectedVar.max_chars < count)
                    count = this.props.activeDesignerVariants[varI].selectedVar.max_chars;
            }
        }

        return count;
    }


    handleSuggestTextSelect(text) {


        for (var l = 0; l < this.props.contentLayers.length; l++) {
            var layer = this.props.contentLayers[l];
            if (layer.perspectiveId == this.props.perspective.id && layer.type == 'text' && layer.perspective_varid == this.props.perspective.varid)
            {
                const maxChars = this.getMaxCharsCount();
                
                if (text.length > maxChars)
                    text = text.substr(0, maxChars);

                layer.content = text;
                const self = this;

                self.props.onContentLayerChange(layer, true);

                break;
            }
        }
    }

    handleSelect(bg, layer) {
        this.props.onPerspectiveLayerSelect(bg, layer);
    }

    handleContentLayerChange(layer) {
        this.props.onContentLayerChange(layer);
    }

    render() {

        const background = this.props.backgrounds.find((bg) => {
            return bg.background_id == this.props.activeBackgroundVariant.id && bg.perspective_id == this.props.perspective.id && bg.perspective_varid == this.props.perspective.varid
        });

        const hasSuggestTexts = (this.props.perspective.suggest_texts !== undefined && this.props.perspective.suggest_texts.length > 0);

        return (
            <div className={"designer_perspective_editor designer_controll row" + (this.props.active ? ' active': '')}>
                <div className="designer_controll_title col-sm-2 col-md-1">
                    <PerspectiveSelectItem
                        perspective={this.props.perspective}
                        background={background}
                        active={this.props.active}
                        onPerspectiveSelect={this.handleSelect}
                    />
                </div>
                <div className="designer_controll_actions col-sm-10 col-md-11">
                    {
                        hasSuggestTexts ?
                        <div className="hidden-xs col-sm-5 col-md-4">
                            <TextSuggestBox
                                perspective={this.props.perspective}
                                onSuggestTextSelect={this.handleSuggestTextSelect}
                            />
                        </div>
                        :null
                    }
                    <div className="col-sm-5 col-md-4">
                        {
                            this.props.perspective.max_lines > 0 ?
                                <TextEditorBox
                                    activeTexts={this.props.activeTexts}
                                    perspective={this.props.perspective}
                                    contentLayers={this.props.contentLayers}
                                    activeDesignerVariants={this.props.activeDesignerVariants}
                                    onPerspectiveLayerSelect={this.handleSelect}
                                    onContentLayerChange={this.handleContentLayerChange}
                                />
                            :
                                <div><br /><br />Hier ist keine Texteingabe möglich!</div>
                        }

                    </div>
                    <div className="col-sm-2 col-md-4">
                    </div>
                </div>
                <div style={{ clear: 'left' }} />
            </div>
        );
    }
  }
export default DesignerPerspectiveEditor;



// WEBPACK FOOTER //
// ./src/DesignerPerspectiveEditor.js